import { useCallback, useMemo } from 'react';

import { AppServiceFactory } from '@/modules/app/service/AppServiceFactory';
import {
  useReferenceExistsAndIsNotScaledSelector,
  useReferenceImageUIStore,
} from '@/modules/referenceImage';
import { TabProps, TabsComponent } from './Tabs';
import { Module } from '@/modules/app/types';

export const TabsMain = () => {
  const { referenceExistsAndIsNotScaled } = useReferenceExistsAndIsNotScaledSelector();
  const { referenceImageActions } = useReferenceImageUIStore();

  const appSvc = useMemo(() => AppServiceFactory.getInstance().createAppService(), []);

  const tabLabels = useMemo<TabProps[]>(
    () => [
      {
        label: 'Setup',
        trans: 'tabs.setup',
        disableTab: false,
        id: 'canvas_setup',
      },
      {
        label: 'Layout',
        trans: 'tabs.layout',
        disableTab: false,
        id: 'canvas_layout',
      },
      {
        label: 'Simulation',
        trans: 'tabs.simulation',
        disableTab: false,
        id: 'canvas_simulation',
      },
    ],
    [],
  );

  const onChange = useCallback(
    (nextModule: Module) => {
      // appSvc.resetTool();

      if (referenceExistsAndIsNotScaled) {
        appSvc.goToModule('canvas_setup');
        referenceImageActions.setRequiredScalingDialogOpenState(true);
        return;
      }

      appSvc.goToModule(nextModule);
    },
    [appSvc, referenceExistsAndIsNotScaled, referenceImageActions],
  );

  return (
    <TabsComponent tabLabels={tabLabels} onChange={onChange} sx={{ padding: '16px 16px 0' }} />
  );
};
